
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plans/[guid]",
      function () {
        return require("private-next-pages/plans/[guid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plans/[guid]"])
      });
    }
  